import { render, staticRenderFns } from "./PazienteTeleconsulto.vue?vue&type=template&id=530b1744&scoped=true"
import script from "./PazienteTeleconsulto.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsulto.vue?vue&type=script&lang=js"
import style0 from "./PazienteTeleconsulto.vue?vue&type=style&index=0&id=530b1744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b1744",
  null
  
)

export default component.exports